var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "ds-checkbox",
      class: { "ds-checkbox--disabled": _vm.disabled },
    },
    [
      _c(
        "span",
        {
          staticClass: "ds-checkbox-box",
          class: { "ds-checkbox-box--checked": _vm.checked },
        },
        [
          _vm.checked
            ? _c("ds-icon", { attrs: { name: "check", size: 14 } })
            : _vm._e(),
        ],
        1
      ),
      _c("input", {
        staticClass: "ds-checkbox-input",
        attrs: { type: "checkbox", disabled: _vm.disabled },
        domProps: { checked: _vm.checked },
        on: {
          change: function ($event) {
            return _vm.$emit("change", $event)
          },
        },
      }),
      _vm._v(" " + _vm._s(_vm.label) + " "),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }